import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-aams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-aams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { ViewApplicationService } from "../../../view-application.service";
import { ViewApplicationLocationAamsConstants } from "./view-application-location-aams.constants";
import { MapService } from "../../../../../map/shared/map.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationLocationAamsComponent = class ViewApplicationLocationAamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appControllerService;
    routerParamsService;
    changeDetectorRefs;
    mapService;
    viewApplicationService;
    activeTabIndex;
    advertisementsForm;
    descriptionLabel1 = ViewApplicationLocationAamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationAamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationAamsConstants.DESCRIPTION_LABEL_3;
    validationMessages = ViewApplicationLocationAamsConstants.VALIDATION_MESSAGES;
    areaOfDisplayFormControlName = ViewApplicationLocationAamsConstants.AREA_OF_DISPLAY_FORM_CONTROL_NAME;
    streetNamesFormControl = ViewApplicationLocationAamsConstants.STREET_NAMES_FORM_CONTROL;
    propertyDescriptionFormControlName = ViewApplicationLocationAamsConstants.PROPERTY_DESCRIPTION_FORM_CONTROL_NAME;
    addressOrStreetFormControlName = ViewApplicationLocationAamsConstants.ADDRESS_OR_STREET_FORM_CONTROL_NAME;
    areaOfDisplayLabel = ViewApplicationLocationAamsConstants.AREA_OF_CONTROL_LABEL;
    streetNamesLabel = ViewApplicationLocationAamsConstants.STREET_NAMES_LABEL;
    propertyDescriptionLabel = ViewApplicationLocationAamsConstants.PROPERTY_DESCRIPTION_LABEL;
    addressOrStreetLabel = ViewApplicationLocationAamsConstants.ADDRESS_OR_STREET_LABEL;
    removeFeatureLabel = ViewApplicationLocationAamsConstants.REMOVE_FEATURE_LABEL;
    showApplicationTypeNotSelectedPage = false;
    selectedApplicationStatus;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    areaOfDisplayLookups = LookupConstants.AREA_OF_DISPLAY_LOOKUPS_A;
    showPermanentApplicationsFields = false;
    showTemporaryApplicationsFields = false;
    isMapLoaded = false;
    sketchTool;
    selectedGraphic = null;
    mapComponent;
    application;
    getApplicationsQuerySubscription;
    getStepMetaObservableSubscription;
    getTrueCentroidSubscription;
    constructor(aflaModuleStrategyService, route, appControllerService, routerParamsService, changeDetectorRefs, mapService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appControllerService = appControllerService;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.getApplicationData();
        this.changeDetectorRefs.detectChanges();
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    getAdvertisements() {
        return this.advertisementsForm.get("advertisements");
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getAdvertisements().controls.forEach(advertisementLocationControl => {
            const geom = advertisementLocationControl.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Advertising graphics", true);
        }
    }
    onGetApplicationDataCompleted(application) {
        const advertisementsFormArray = this.getAdvertisements();
        const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.shape, 102100);
        advertisementsFormArray.clear();
        const advertisementLocationFormGroup = this.createAdvertisementFormGroup(application);
        this.showFieldsBasedOnSelectedAdvertisementType(application);
        const url = this.getGPToolURL();
        const formData = this.getGPToolFormData(geometryArc);
        this.getTrueCentroidSubscription = this.viewApplicationService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                this.setTrueCentroid(advertisementLocationFormGroup, trueCentroidResponse);
                if (this.isMapLoaded) {
                    this.syncMapGeometries();
                }
                this.changeDetectorRefs.detectChanges();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationLocationAamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    setTrueCentroid(newFormGroup, trueCentroidResponse) {
        const advertisementsArray = this.getAdvertisements();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        advertisementsArray?.clear();
        advertisementsArray.push(newFormGroup);
        this.activeTabIndex = advertisementsArray.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.advertisementsForm = this.aflaModuleStrategyService.form.get("advertisementsForm");
        this.activeTabIndex = 0;
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.getApplicationData();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getApplicationData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `point, polygon`
        };
        this.getApplicationsQuerySubscription = this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
            next: (response) => {
                if (response.value.length > 0) {
                    this.application = response.value[0];
                    this.onGetApplicationDataCompleted(this.application);
                }
            },
            error: (error) => this.appControllerService.handleServerErrorMessage("application", error, CRUDOperation.Get)
        });
    }
    createAdvertisementFormGroup(application) {
        let geometryArc;
        if (application.isAdvetisingPermanentOrTemporary?.toLowerCase()?.trim() === "permanent") {
            geometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.point.shape, 102100);
        }
        else {
            geometryArc = WktConverterUtils.ConvertWktToArcGisJson(application.polygon.shape, 102100);
        }
        const geom = JsonUtils.fromJSON(geometryArc);
        return new FormGroup({
            areaOfDisplay: new FormControl({ value: application.polygon?.areaOfDisplay, disabled: true }),
            streetNames: new FormControl({ value: application.polygon?.streetNames, disabled: true }),
            propertyDescription: new FormControl({ value: application.polygon?.propertyDescription, disabled: true }),
            streetOrAddress: new FormControl({ value: application.frontalArea, disabled: true }),
            addressStreetInformation: new FormControl({ value: application.point?.addressStreetInformation, disabled: true }),
            geometry: new FormControl(geom),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    showFieldsBasedOnSelectedAdvertisementType(application) {
        if (application.isAdvetisingPermanentOrTemporary?.toLowerCase()?.trim() === "permanent") {
            this.showPermanentApplicationsFields = true;
            this.showTemporaryApplicationsFields = false;
        }
        if (application.isAdvetisingPermanentOrTemporary?.toLowerCase().trim() === "temporary") {
            this.showTemporaryApplicationsFields = true;
            this.showPermanentApplicationsFields = false;
        }
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esriMap", { static: false },] }]
    };
};
ViewApplicationLocationAamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-aams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationAamsComponent);
export { ViewApplicationLocationAamsComponent };
